import {OptionOffer} from './option-offer.entity';


export class SubscriptionOffer {
  id: number;

  code: string;

  site: string;

  period: number;
  subscription_option_offers: OptionOffer[];
}



// WEBPACK FOOTER //
// /app/src/app/entities/subscription-offer.entity.ts